export default (num, singular, plural, omitNumber) =>
  `${!omitNumber ? `${num} ` : ''}${num === 1 ? singular : plural}`
